import goto from ".";

export default {
  exitDynamicSurvey() {
    goto.exitBuyflow("LANDING");
  },
};
